import {COUNTRY, CURRENCY, AMOUNT} from "app/model/calculator";
import {first, isInteger, isNaN} from 'lodash';
import {CalculatorActions} from "actions/calculatorActions";
import {Amount} from "app/model/amount";

export class CalculatorHandler {
    constructor(dispatch) {
        this.dispatch = dispatch;
        this.actions = CalculatorActions();
    }

    async onCountryChange(state, type, country) {
        if (type === COUNTRY.IN) {
            const availableCountriesOut = state.directions[country];
            this.dispatch(this.actions.setCountryInAction(country));
            this.dispatch(this.actions.setAvailableCountriesOutAction(availableCountriesOut));

            if (!availableCountriesOut.includes(state.countryOut)) {
                this.dispatch(this.actions.setCountryOutAction(first(availableCountriesOut)));
            }
        }

        if (type === COUNTRY.OUT) {
            this.dispatch(this.actions.setCountryOutAction(country));
        }

        await this.dispatch(this.actions.loadAvailableCurrenciesAction());
        await this.dispatch(this.actions.getExchangeRateAction());
        await this.dispatch(this.actions.loadAvailableDeliveryMethodsAction());
    }

    async onCurrencyChange(state, type, currency) {
        const amountType = type === CURRENCY.IN ? AMOUNT.IN : AMOUNT.OUT;
        const amount = Amount.createMoney(state[amountType].getAmount, currency);
        this._setAmountAction(amountType, amount);

        if (type === CURRENCY.IN) {
            const availableCurrenciesOut = state.currencies[currency];
            this.dispatch(this.actions.setAvailableCurrenciesOutAction(availableCurrenciesOut));

            const amountOut = Amount.createMoney(state[AMOUNT.OUT].getAmount, first(availableCurrenciesOut));
            if (!availableCurrenciesOut.includes(state[AMOUNT.OUT].currency)) {
                this._setAmountAction(AMOUNT.OUT, amountOut);
            }
        }

        await this.dispatch(this.actions.getExchangeRateAction());
        return this.dispatch(this.actions.loadAvailableDeliveryMethodsAction());
    }

    onAmountChange(state, type, value) {
        value = Number(value);

        if (isNaN(value)) {
            return;
        }

        if (value <= 0) {
            value = 50000;
        }

        if (!isInteger(value)) {
            value = parseInt(value * 100);
        }

        const amount = Amount.createMoney(value, state[type].getCurrency);
        this._setAmountAction(type, amount);

        return this.dispatch(this.actions.loadAvailableDeliveryMethodsAction());
    }

    onDeliveryMethodChange(method) {
        const {fee} = method;

        this.dispatch(this.actions.setDeliveryMethodAction(method));
        this.dispatch(this.actions.setFeeAction(fee.chosen));
    }

    /** @private */
    _setAmountAction(type, amount) {
        const action = type === AMOUNT.IN ? this.actions.setAmountInAction(amount) :
            this.actions.setAmountOutAction(amount);

        return this.dispatch(action);
    }
}
